<template>
  <div class="mwm-tos-body">
    <span v-if="!tosError" v-html="tosData.body" />
  </div>
</template>

<script>
import Vue from 'vue';

export default {
  data: () => ({
    tosData: '',
    tosError: false
  }),
  components: {

  },
  methods: {
    fetchTosData () {
      const appKey = this.$route.params.app_key
      if (!appKey) { return }
      const url = `https://storage.googleapis.com/mwm-web-static/tos/${appKey}.html`
      Vue.http.get(url)
        .then((response) => {
          this.tosData = response
          this.tosError = false
        })
        .catch(() => {
          this.tosError = true
        });
    }
  },
  computed: {

  },
  mounted () {
    this.fetchTosData()
  }
};
</script>

<style lang="css">
@media (max-width: 960px) {
  .mwm-tos-body {
    width: 90%!important;
  }
}

.v-application p {
  margin-bottom: unset!important;
}

.mwm-tos-body {
  position: relative;
  margin-left: 5%;
  margin-top: 5%;
  width: 30%;
  height: 100%;
  line-height: 1.15;
}
</style>
